import { Capacitor } from '@capacitor/core';
import { AmplitudeCapacitorPlugin } from '../../capacitor_plugins/amplitude';

import { CAPACITOR_AMPLITUDE_PLUGIN } from '../../capacitor_plugins/pluginConstants';
import { AMPLITUDE_USER_PROPS } from '../../common/analytics/statsConstants';
import platformSingleton from '../platform/platformSingleton';
import { withPayloadLogging } from '../capacitor/capacitorPayloadLogging';
import globalLogger from '../logger/logger';

const logger = globalLogger.createChannel('analytics.amplitude');

const warnAmplitudeNotAvailable = (fn) => (args) => {
    logger.warn('Amplitude is attempting to be invoked but not available', { functionName: fn.name, args });
};

const ifAmplitudeIsAvailable =
    (fn) =>
    (...args) => {
        if (Capacitor.isPluginAvailable(CAPACITOR_AMPLITUDE_PLUGIN)) {
            fn(...args);
        } else {
            warnAmplitudeNotAvailable(fn)(...args);
        }
    };

export const setAmplitudeUser = ifAmplitudeIsAvailable((user) => {
    withPayloadLogging(
        `${CAPACITOR_AMPLITUDE_PLUGIN}.setUserId`,
        (payload) => AmplitudeCapacitorPlugin.setUserId(payload),
        { userId: user._id },
    );
});

export const clearAmplitudeUder = ifAmplitudeIsAvailable(() => {
    AmplitudeCapacitorPlugin.setUserId({ userId: null });
});

export const sendAmplitudeUserProperties = ifAmplitudeIsAvailable(({ userProperties = {} }) => {
    // Ensure the platform is always correct
    userProperties[AMPLITUDE_USER_PROPS.APPLICATION_PLATFORM] = platformSingleton.applicationPlatform;

    withPayloadLogging(
        `${CAPACITOR_AMPLITUDE_PLUGIN}.sendAmplitudeUserProperties`,
        (payload) => AmplitudeCapacitorPlugin.setUserProperties(payload),
        { properties: userProperties },
    );
});

export const sendAmplitudeEvent = ifAmplitudeIsAvailable(({ eventType, eventProperties, userProperties }) => {
    sendAmplitudeUserProperties({ userProperties });

    if (eventType) {
        return withPayloadLogging(
            `${CAPACITOR_AMPLITUDE_PLUGIN}.sendAmplitudeEvent`,
            (payload) => AmplitudeCapacitorPlugin.sendEvent(payload),
            { eventType, eventProperties },
        );
    }
});
